<!-- <p>navbar works!</p> -->
<nav class="navbar">
  <!-- Brand (optional) -->
  <div class="brand" aria-label="App brand">
    <!-- <div class="brand-badge">A</div> -->
    <!-- <div class="brand-title">
      App Console
      <small>Red • Black • White</small>
    </div> -->
  </div>

  <!-- Left: icons toolbar -->
  <div class="toolbar" role="toolbar" aria-label="Main toolbar">
    <button class="icon-btn" type="button" title="Edit" (click)="onAction('edit')">
      <i class="fa-solid fa-pen-to-square"></i>
      <!-- <span>Edit</span> -->
    </button>

    <button class="icon-btn" type="button" title="Filter" (click)="onAction('filter')">
      <i class="fa-solid fa-filter"></i>
      <!-- <span>Filter</span> -->
    </button>

    <!-- <button class="icon-btn" type="button" title="Remove Filter" (click)="onAction('removeFilter')"> -->
      <!-- <i class="fa-solid fa-filter-circle-xmark"></i> -->
      <!-- <span>Remove Filter</span> -->
    <!-- </button> -->

    <button class="icon-btn red" type="button" title="Add" (click)="onAction('add')">
      <i class="fa-solid fa-plus"></i>
      <!-- <span>Add</span> -->
    </button>

    <button class="icon-btn" type="button" title="Delete" (click)="onAction('delete')">
      <i class="fa-solid fa-trash"></i>
      <!-- <span>Delete</span> -->
    </button>

    <div class="divider" aria-hidden="true"></div>
       <button class="icon-btn" type="button" title="Settings" (click)="onAction('settings')">
      <i class="fa-solid fa-gear"></i>
      <!-- <span>Settings</span> -->
    </button>

    <button class="icon-btn" type="button" title="Refresh" (click)="onAction('refresh')">
      <i class="fa-solid fa-rotate"></i>
      <!-- <span>Refresh</span> -->
    </button>

    <button class="icon-btn" type="button" title="Status" (click)="onAction('status')">
      <i class="fa-solid fa-signal"></i>
      <span>Status</span>
      <span class="status-dot" [class.offline]="!isOnline" aria-label="Online status"></span>
    </button>

 

    <button class="icon-btn" type="button" title="Saved Filters" (click)="onAction('savedFilters')">
      <i class="fa-solid fa-bookmark"></i>
      <span>Saved Filters</span>
    </button>

    <button class="icon-btn" type="button" title="View Transactions" (click)="onAction('viewTransactions')">
      <i class="fa-solid fa-receipt"></i>
      <span>View Transactions</span>
    </button>
  </div>

  <!-- Right: three buttons -->
  <div class="actions" aria-label="Quick actions">
    <!-- Dynamic menu buttons -->
    <ng-container *ngIf="data?.menu">
      <button *ngFor="let item of data.menu" class="pill" type="button" [title]="item.label" (click)="onAction(item.actionId)">
        <i class="fa-solid fa-cubes"></i><span>{{ item.label }}</span>
      </button>
    </ng-container>

    <!-- <button class="pill outline" type="button" title="Model View" (click)="onAction('modelView')">
      <i class="fa-solid fa-cubes"></i><span>Model View</span>
    </button> -->

    <!-- <button class="pill red" type="button" title="Explorer" (click)="onAction('explorer')">
      <i class="fa-solid fa-compass"></i><span>Explorer</span>
    </button> -->
     <button class="pill" type="button" title="Quote" (click)="onAction('quotes')">
      <i class="fa-solid fa-cubes"></i><span>Quote</span>
    </button>

    <button class="pill" type="button" title="Notifications" (click)="onAction('notifications')">
      <i class="fa-solid fa-bell"></i><span>Notifications</span>
    </button>
  </div>
</nav>
